import portfolioData from '../../data/portfolioData';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>
          <p className="footer__brand">{portfolioData.name}</p>
          <p className="footer__role">{portfolioData.profession}</p>
        </div>

        <div className="footer__links">
          <a href="#projects">Projects</a>
          <a href="#experience">Experience</a>
          <a href="#contact">Contact</a>
          <a href={portfolioData.cvPath} download="Abrham-Tesfaye-CV.pdf">
            Download CV
          </a>
        </div>

        <p className="footer__copy">© {year} {portfolioData.name}. Built with care.</p>
      </div>
    </footer>
  );
};

export default Footer;
